import React, { useContext, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import PrivateLayout from '../components/PrivateLayout';
import { LangContext } from '../App';

const OR = 'var(--couleur-or)';

const T = {
  fr: {
    title: 'Paiement confirmé',
    soustitre: 'Merci, votre réservation est maintenant payée.',
    refIntent: 'Référence Stripe',
    contratPdf: '📄 Voir le contrat (PDF)',
    contratBientot: 'Contrat PDF available bientôt — un email vous sera envoyé.',
    voirReservations: 'Voir mes réservations',
    retourTdb: '← Retour au tableau de bord',
  },
  en: {
    title: 'Payment confirmed',
    soustitre: 'Thanks, your reservation has been paid.',
    refIntent: 'Stripe reference',
    contratPdf: '📄 View contract (PDF)',
    contratBientot: 'Contract PDF coming soon — you will receive an email.',
    voirReservations: 'View my bookings',
    retourTdb: '← Back to dashboard',
  },
};

export default function PaiementSucces() {
  const { lang } = useContext(LangContext);
  const t = T[lang];
  const [params] = useSearchParams();
  const paymentIntent = params.get('payment_intent');
  const miseId = params.get('bid_id');

  // Petit délai « cosmétique » pour laisser le webhook arriver côté serveur
  // avant que l'utilisateur clique sur « Voir mes réservations ».
  const [pret, setPret] = useState(false);
  useEffect(() => {
    const id = setTimeout(() => setPret(true), 1500);
    return () => clearTimeout(id);
  }, []);

  return (
    <PrivateLayout>
      <div
        style={{ maxWidth: '640px', margin: '0 auto', padding: '3rem 1.5rem', textAlign: 'center' }}
      >
        <div style={{ fontSize: '4rem', marginBottom: '0.5rem' }}>✅</div>
        <h1
          style={{
            fontFamily: 'Georgia, serif',
            fontSize: '1.8rem',
            color: 'var(--couleur-texte)',
            margin: 0,
          }}
        >
          {t.title}
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.95rem', marginTop: '0.6rem' }}>
          {t.soustitre}
        </p>

        {paymentIntent && (
          <div
            style={{
              display: 'inline-block',
              marginTop: '1.3rem',
              background: 'rgba(255,255,255,0.025)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '8px',
              padding: '0.7rem 1.2rem',
              fontSize: '0.78rem',
              color: 'rgba(255,255,255,0.6)',
            }}
          >
            <span style={{ color: 'rgba(255,255,255,0.35)' }}>{t.refIntent} : </span>
            <code style={{ color: OR, fontFamily: 'monospace' }}>{paymentIntent}</code>
          </div>
        )}

        <div
          style={{
            marginTop: '1.8rem',
            background: 'rgba(255,255,255,0.02)',
            border: '1px dashed rgba(184,134,11,0.4)',
            borderRadius: '8px',
            padding: '1rem 1.2rem',
            color: 'rgba(255,255,255,0.5)',
            fontSize: '0.85rem',
          }}
        >
          🗎 {t.contratBientot}
        </div>

        <div
          style={{
            marginTop: '2rem',
            display: 'flex',
            gap: '0.7rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <Link
            to="/dashboard"
            style={{
              background: OR,
              color: 'var(--couleur-fond-carte)',
              padding: '0.7rem 1.2rem',
              borderRadius: '8px',
              fontSize: '0.9rem',
              fontWeight: 700,
              textDecoration: 'none',
              opacity: pret ? 1 : 0.65,
              pointerEvents: pret ? 'auto' : 'none',
            }}
          >
            {t.voirReservations}
          </Link>
          {miseId && (
            <Link
              to={`/dashboard`}
              style={{
                background: 'transparent',
                color: 'rgba(255,255,255,0.55)',
                border: '1px solid rgba(255,255,255,0.18)',
                padding: '0.7rem 1.2rem',
                borderRadius: '8px',
                fontSize: '0.82rem',
                textDecoration: 'none',
              }}
            >
              {t.retourTdb}
            </Link>
          )}
        </div>
      </div>
    </PrivateLayout>
  );
}
